import {changeNestedValue} from "@Common/utils/arr-path";
import {waitTimeout}       from "@Common/utils/wait-timeout";

import {createMockState} from "./create-mock-state";

const cartState = createMockState(
    require("./sample-data/sample-cart")
    // require("./sample-data/sample-cart-shipping-consolidation")
);

export const mockNextCartApis = {
    checkoutCart: async () => {
        localStorage.cartStatus = "processing";

    },
    getCurrentCart: async () => ({
        ...cartState.get(),
        status: localStorage.cartStatus,
    }),
    createCart: async () => ({}),
    emptyCart: async () => {
        console.log("emptyCart");
    },
    addItemsToCart: async () => require("./sample-data/sample-cart"),
    getCart: async () => {
        // await waitTimeout(15000);
        return ({
            ...cartState.get(),
            status: localStorage.cartStatus,
        });
    },
    validateCart: async () => ({
        ...cartState.get(),
        status: localStorage.cartStatus,
    }),
    // validateCart: async () => {
    //     throw "DAEWE";
    // },
    deleteItemsFromCart: async () => ({result: "success"}),
    updateCart: async ({cartId, payments=undefined, removeCredits = undefined, removePayments=undefined, credits, shipping=undefined}) => {
        // console.log("API updateCart");
        // return {
        //     "paymentErrors": {
        //         "copays":[
        //             {
        //                 "itemId": 10248711,
        //                 "errors": [
        //                     {
        //                         "itemId": "10246673(Pending)",
        //                         "creditUsed": 44.38000000000000255795384873636066913604736328125
        //                     }
        //                 ]
        //             }
        //         ],
        //     }
        // };
        //
        await waitTimeout(100);

        console.log("updateCart", {
            removePayments,
            payments,
            shipping,
        });

        let cart = cartState.get();
        let appliedPayments = cart.appliedPayments;

        if (removePayments) {
            if (removePayments.billing?.length) {
                cart = changeNestedValue(cart, ["appliedPayments", "billing"], () => null);
            }
            if (removePayments.creditCards?.length) {
                cart = changeNestedValue(cart, ["appliedPayments", "creditCards"], (creditCards) =>
                    creditCards?.filter((c1) => !removePayments.creditCards?.find((c) => c.cardToken === c1.cardToken))
                );
            }
            // if (removePayments.credits) {
            //     cart = changeNestedValue(cart, ["appliedCredits"], () =>
            //         null
            //     );
            // }
        }
        if (payments) {
            // console.log("payments", payments);
            if (payments.billing) {
                cart = changeNestedValue(cart, ["appliedPayments", "billing"], (billing) =>
                    [
                        ...billing||[],
                        ...payments.billing?.map((b) => ({
                            ...b,
                            "name": "Test billing",
                            "amount": 77.7,
                        })) ?? [],
                    ]
                );
            }
            if (payments.creditCards) {
                // console.log("payments.creditCards", payments.creditCards);
                cart = changeNestedValue(cart, ["appliedPayments", "creditCards"], () =>
                    payments.creditCards
                );
            }
        }
        if (credits) {
            cart = changeNestedValue(cart, ["appliedCredits", "copays"], (copays) =>
                [
                    ...copays||[],
                    ...credits.copays?.map((copay) => ({
                        ...copay,
                        "amount": 77.7,
                    })) ?? [],
                ]
            );

            cart = changeNestedValue(cart, ["appliedCredits", "promoCodes"], () => credits.promoCodes?.map(({code}) => ({
                code,
                itemId: "123123",
                amount: 1,
            })));
            cart = changeNestedValue(cart, ["paymentErrors", "promoCodes"], () => credits.promoCodes?.map(({code}) => ({
                code,
                itemId: "123123",
                error: 1,
                promoCodeMessage: "feroferi",
            })));

            cart = changeNestedValue(cart, ["appliedCredits", "adBudgets"], () => credits.adBudgets);
        }
        if (removeCredits) {
            if (removeCredits.adBudgets) {
                cart = changeNestedValue(cart, ["appliedCredits", "adBudgets"], () => null);
            }
        }
        if (shipping) {
            cart = changeNestedValue(cart, ["shipping"], () => ({
                ...shipping,
                estimatedDeliveryMessage: "Thursday, Jul 29, 2021 by 12:00pm Local Time",

                isServiceLevelAvailableForAllItems: true,
                weightSurcharge: false,
            }));
        }

        cartState.set(cart);

        // console.log("result cart", cart);

        return {
            ...cart,
            // errors: payments ? null : "AWWAW",
            // paymentErrors: !payments ? null : {
            //     "billing": [
            //         {
            //             "type": "fieldError",
            //             "billingId": "0273b610",
            //             "field": "meta1",
            //             "error": "Invalid value",
            //             "itemId": 1234
            //         }
            //     ]
            // },
        };
        // return {
        //     ...cart,
        //     items: cart.itemIds.map((itemId) => itemState.get()),
        // };
    },

    getCartApproval: async (cartId) => {
        return {
            "approvalDetails": {
                "10784252": {
                    "approvalRequired": true,
                    "enableApprovalButton": 1,
                    "billingTotalExceeded": false,
                    "approvalName": "Submit for Approval",
                    "idOrderApproval": 2296
                }
            }
        };
    },

    createApprovalRequest: async () => ({}),

    getSubscriptionBenefits: async ({cartId}) => {
        return {totalSavings: 100};
        // return {"result": "failure","errors": {"target": "getCartSubscriptionsBenefits","msg": "Not able to locate given Cart Id"}};
        // /subscriptions/subscriptionBenefits/cart/{idCart}
        // {totalSavings: 100}
        // {"result": "failure","errors": {"target": "getCartSubscriptionsBenefits","msg": "Not able to locate given Cart Id"}}

    },
};

